import * as yup from 'yup';

import { emailRegExp } from './emailValidation';

const phoneRegExp = /^\D*(?:\d\D*){9,}$/;

const validateEmail = (email: string) => emailRegExp.test(email);

const validatePhone = (phone: string) =>
  yup
    .string()
    .required()
    .test((phoneNumber: string) => phoneRegExp.test(phoneNumber))
    .isValidSync(phone);

export const friendSchemaValidation = yup.object().shape(
  {
    givname: yup.string().when(['surname', 'phoneOrEmail'], {
      is: (surname: string, phoneOrEmail: string) =>
        Boolean(surname) || Boolean(phoneOrEmail),
      then: (s) => s.required(),
      otherwise: (s) => s
    }),
    surname: yup.string().when(['givname', 'phoneOrEmail'], {
      is: (givname: string, phoneOrEmail: string) =>
        Boolean(givname) || Boolean(phoneOrEmail),
      then: (s) => s.required(),
      otherwise: (s) => s
    }),
    phoneOrEmail: yup.string().when(['givname', 'surname'], {
      is: (givname: string, surname: string) =>
        Boolean(givname) || Boolean(surname),
      then: (s) =>
        s
          .required('Email / Phone is required')
          .test(
            'email_or_phone',
            'Email / Phone is invalid',
            (value: string) => {
              const isEmailValid = validateEmail(value ?? '');
              const isPhoneValid = validatePhone(value ?? '');
              return isEmailValid || isPhoneValid;
            }
          ),
      otherwise: (s) => s
    })
  },
  [
    ['givname', 'surname'],
    ['givname', 'phoneOrEmail'],
    ['surname', 'phoneOrEmail']
  ]
);
